module.exports = __webpack_public_path__ + "static/L2_ux_2_1_eg-9432d782781d271850bbac3a68577b05.png";